// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-muted[data-v-63b2504d]{color:#999}.notification-item[data-v-63b2504d]{cursor:pointer}.notification-item[data-v-63b2504d]:hover{background-color:#0d1b54}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
